import Image from 'next/image';

import { PRODUCT_IMAGE_PATH } from '@shared/config/paths/paths';

import cls from './CartNotification.module.scss';

type CartNotificationProps = {
  image: string;
  text: string;
};

export const CartNotification = ({ image, text }: CartNotificationProps) => {
  return (
    <div className={cls.wrap}>
      <div className={cls.img}>
        {image ? (
          <Image
            src={`${PRODUCT_IMAGE_PATH}/${image}/200.webp`}
            alt={''}
            fill
          />
        ) : (
          <div className={cls.empty}>image</div>
        )}
      </div>

      <div className={cls.label}>{text}</div>
    </div>
  );
};
